import React from 'react';
import gift from '../../images/donation/gift.png';

export default function SupportSection({
  setShowPopup,
  hasDonated,
  donationAmount = 0,
  onDonationComplete,
  onAdjustDonation,
}) {
  return (
    <div className="support-section">
      <div>
        <p className="support-title">{hasDonated ? '🌼 Thank You for Your Generosity' : 'Support Lineage Journey'}</p>
        <p className="support-text">
          {hasDonated
            ? `Your $${donationAmount.toFixed(
                2
              )} donation was successful. You're helping keep these stories alive for future generations.`
            : 'Your generosity helps us preserve stories of faith, heritage and identity for generations to come.'}
        </p>
        {hasDonated && (
          <button
            className="adjust-donation-btn"
            onClick={() => {
              setShowPopup(true);
            }}
          >
            <div style={{ display: 'flex', gap: '8px', whiteSpace: 'nowrap' }}>Adjust donation</div>
          </button>
        )}
      </div>
      {hasDonated && <img src={gift} alt="gift" className="gift-img" />}

      {!hasDonated && (
        <button
          className="donate-btn"
          onClick={() => {
            setShowPopup(true);
          }}
        >
          <div style={{ display: 'flex', gap: '8px' }}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10.504 2.58106C9.084 2.83556 7.9985 4.53356 7.9985 4.53356C7.9985 4.53356 6.9085 2.83556 5.4925 2.58106C1.9865 1.95606 0.541003 5.07756 1.1265 7.40106C1.9915 10.8326 6.153 13.9081 7.5435 14.8591C7.8185 15.0471 8.1785 15.0471 8.4585 14.8591C9.854 13.9081 14.015 10.8326 14.8755 7.40106C15.4555 5.07756 14.0105 1.95606 10.504 2.58106Z"
                fill="#F8312F"
              />
            </svg>
            DONATE
          </div>
        </button>
      )}
    </div>
  );
}
